var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_common_dv flex"},[_c('p',[_vm._v("前端基于Vue-cli3.0.0-0")]),_c('p',[_vm._v("后端（Tp6版：ThinkPHP-v6.0.3）")]),_c('p',[_vm._v("小说后台")])])
}]

export { render, staticRenderFns }